export interface AppConfig {
  cliendId: string;
  tenantId: string;
  connectionStringAppInsights: string;
  redirectUrl: string;
  portalUrl: string;
  servicePlannenUrl: string;
  servicePortfolioUrl: string;
  servicePlanManagementUrl: string;
  serviceBestuurlijkeGebiedenUrl: string;
  serviceUserManagementUrl: string;
  serviceOrganisatiesUrl: string;
  serviceAssetsUrl: string;
}
  
export const loadConfigJson = async (): Promise<AppConfig> => {
  try {
    const response = await fetch('/data/config.json');
    if (!response.ok) {
      throw new Error(`Failed to load config.json: ${response.statusText}`);
    }
    const config: AppConfig = await response.json();
    return config;
  }
  catch (error) {
    console.error('Error loading config.json:', error);
    throw error;
  }
};
  